<template>
  <div class="home_wrap">
    <Header></Header>
    <van-row class="topSection">
      <van-col span="6" style="text-align: left">
        <router-link to="/member">
          <img src="../images/common/backArrow.png" class="imageback"
        /></router-link>
      </van-col>
      <van-col span="18" style="text-align: right">
        <span style="color: #ffffff; font-size: 30px; font-weight: 700">{{
          $t("settings.settings")
        }}</span>
      </van-col>
    </van-row>
    <van-row style="padding: 10px">
      <van-row class="settingsBox">
        <!-- --------- nick name ------ -->
        <van-row style="padding-top: 10px">
          <van-col span="24" style="display: flex; align-items: center">
            <div>
              <span class="userList">{{ $t("settings.nickName") }}:</span>
            </div>
            <div class="linktext">
              <router-link to="/setnickname">
                <span class="userInfo">{{ data.name }}</span>
                <van-icon name="arrow" class="linkIcon" />
              </router-link>
            </div>
          </van-col>
        </van-row>
        <!-- --------- login pasword ------ -->
        <van-row style="padding-top: 28px">
          <van-col span="24" style="display: flex; align-items: center">
            <div>
              <span class="userList">{{ $t("settings.loginPassword") }}:</span>
            </div>
            <div class="linktext">
              <router-link to="/setpwd">
                <span class="userInfo">*****</span>
                <van-icon name="arrow" class="linkIcon" />
              </router-link>
            </div>
          </van-col>
        </van-row>
        <!-- --------- withdrawal password ------ -->
        <van-row style="padding-top: 28px">
          <van-col span="24" style="display: flex; align-items: center">
            <div>
              <span class="userList"
                >{{ $t("settings.withdrawalPassword") }}:</span
              >
            </div>
            <div class="linktext">
              <router-link to="/setpaypwd">
                <span class="userInfo">{{
                  data.withdraw_pass_set
                    ? "******"
                    : $t("settings.passwordNotSet")
                }}</span>
                <van-icon name="arrow" class="linkIcon" />
              </router-link>
            </div>
          </van-col>
        </van-row>
        <!-- --------- phone ------ -->
        <van-row style="padding-top: 28px">
          <van-col span="24" style="display: flex; align-items: center">
            <div>
              <span class="userList">{{ $t("settings.mobile") }}:</span>
            </div>
            <div class="linktext">
              <router-link to="/setphone">
                <span class="userInfo">{{
                  data.mobile == null
                    ? $t("settings.mobileNotSet")
                    : data.mobile
                }}</span>
                <van-icon name="arrow" class="linkIcon" />
              </router-link>
            </div>
          </van-col>
        </van-row>
        <!-- --------- mailbox  ------ -->
        <!-- TODO change email -->
        <van-row style="padding-top: 28px">
          <van-col span="24" style="display: flex; align-items: center">
            <div>
              <span class="userList">{{ $t("settings.email") }}:</span>
            </div>
            <div class="linktext">
              <router-link to="/setemail">
                <span class="userInfo">{{ data.email == null ? $t('settings.emailNotSet'):data.email }}</span>
                <van-icon name="arrow" class="linkIcon" />
              </router-link>
            </div>
          </van-col>
        </van-row>
        <!-- --------- language ------ -->
        <van-row style="padding-top: 28px">
          <van-col span="24" style="display: flex; align-items: center">
            <div>
              <span class="userList">{{ $t("settings.language") }}:</span>
            </div>
            <div class="linktext">
              <router-link to="/language">
                <span class="userInfo">{{ $t("lang.name") }}</span>
                <van-icon name="arrow" class="linkIcon" />
              </router-link>
            </div>
          </van-col>
        </van-row>
        <!-- --------- wallet ------ -->
        <van-row style="padding-top: 28px">
          <van-col span="8" style="display: flex; align-items: center">
            <div>
              <span class="userList">{{ $t("settings.wallet") }}:</span>
            </div>
          </van-col>
          <van-col span="16">
            <div class="linktext">
              <router-link
                :to="{
                  name: 'setwallet',
                  params: {
                    walletHas: data.wallet_has,
                  },
                }"
              >
                <span class="userInfo">{{
                  data.wallet_has
                    ? $t("settings.valueSet")
                    : $t("settings.valueNotSet")
                }}</span>
                <van-icon name="arrow" class="linkIcon" />
              </router-link>
            </div>
          </van-col>
        </van-row>
        <!-- --------- bank card ------ -->
        <van-row style="padding-top: 28px">
          <van-col span="8" style="display: flex; align-items: center">
            <div>
              <span class="userList">{{ $t("settings.bankCard") }}:</span>
            </div>
          </van-col>
          <van-col span="16">
            <div class="linktext">
              <router-link
                :to="{
                  name: 'setbankcard',
                  params: { bankHas: data.bank_has },
                }"
              >
                <span class="userInfo">{{
                  data.bank_has
                    ? $t("settings.valueSet")
                    : $t("settings.valueNotSet")
                }}</span>
                <van-icon name="arrow" class="linkIcon" />
              </router-link>
            </div>
          </van-col>
        </van-row>
      </van-row>
      <van-row style="padding-top: 25px">
        <van-col span="24">
          <div class="logoutBg" @click="logout()">
            <p class="logoutText">{{ $t("settings.logout") }}</p>
          </div>
        </van-col>
      </van-row>
    </van-row>
  </div>
</template>

<script>
import Vue from "vue";
import Header from "../../components/header";
import { Icon, Col, Row } from "vant";
import Fetch from "../../utils/fetch";
Vue.use(Icon).use(Row).use(Col);

export default {
  name: "settings",
  components: {
    Header,
  },
  data() {
    return {
      data: {},
    };
  },
  mounted() {
    this.start();
  },
  methods: {
    logout() {
      localStorage.clear();
      this.$router.push("/");
    },
    start() {
      Fetch("/user/info").then((r) => {
        this.data = r.data;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.home_wrap {
  width: 100%;
  min-height: 100vh;
  background: url("../images/common/BgImg.png");
  background-size: 100% 100%;
}

.topSection {
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 20px 15px 0px;
}

.imageback {
  height: 40px;
  width: auto;
}

.settingsBox {
  box-shadow: rgb(0 0 0 / 24%) 0px 3px 8px;
  border: 1px solid #ffffff;
  border-radius: 13px;
  padding: 15px;
  background: #ebebeb29;
  margin-top: 25px;
}

.logoutBg {
  background: url(../images/member/logoutBtnBg.png);
  background-size: 100% 100%;
}

.logoutText {
  color: #000000;
  font-size: 22px;
  text-align: center;
  padding: 12px 0px;
}

.userList {
  font-size: 17px;
  color: #ebedf0;
}

.userInfo {
  font-size: 17px;
  color: #ffffff;
  padding-left: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.linktext {
  display: flex;
  align-items: center;
  position: absolute;
  right: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.linkIcon {
  color: #ebedf0;
  font-size: 18px;
}
</style>
